import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-66b49ac8")

_pushScopeId("data-v-66b49ac8")
const _hoisted_1 = { class: "FTLOrderHeader" }
const _hoisted_2 = { class: "FTLOrderHeader__information" }
const _hoisted_3 = { class: "information__footer" }
const _hoisted_4 = { class: "information__title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_bread_crumbs = _resolveComponent("s-bread-crumbs")!
  const _component_icon_arrow_left = _resolveComponent("icon-arrow-left")!
  const _component_ftl_order_header_actions = _resolveComponent("ftl-order-header-actions")!
  const _component_ftl_order_confirmation = _resolveComponent("ftl-order-confirmation")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_s_bread_crumbs, { links: _ctx.breadcrumbsLinks }, null, 8, ["links"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_icon_arrow_left, {
          class: "information__back",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
        }),
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.orderId), 1)
      ])
    ]),
    (
                _ctx.FTLOrderState.data &&
                _ctx.FTLOrderState.data.status_code !== _ctx.FTL_STATUS_WAIT_CONFIRM_TOKEN
            )
      ? (_openBlock(), _createBlock(_component_ftl_order_header_actions, {
          key: 0,
          loading: _ctx.FTLOrderConfirmationState.state.is_loading,
          onCancel: _ctx.cancelFTLOrderHandler,
          onPrint: _ctx.emitPrint
        }, null, 8, ["loading", "onCancel", "onPrint"]))
      : _createCommentVNode("", true),
    (
                _ctx.FTLOrderState.data &&
                _ctx.FTLOrderState.data.status_code === _ctx.FTL_STATUS_WAIT_CONFIRM_TOKEN
            )
      ? (_openBlock(), _createBlock(_component_ftl_order_confirmation, {
          key: 1,
          onConfirm: _ctx.confirmFTLOrderHandler,
          onCancel: _ctx.cancelFTLOrderHandler,
          cost: _ctx.FTLOrderState.data.cost,
          loading: _ctx.FTLOrderConfirmationState.state.is_loading
        }, null, 8, ["onConfirm", "onCancel", "cost", "loading"]))
      : _createCommentVNode("", true)
  ]))
})